import { useReactiveVar } from "@apollo/client";
import { DesktopModalBody } from "./desktop";
import { PortalModal } from "~/components/blocks/common/portal-modal";
import { MobileModalBody } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal/mobile";

import { isOpenSampleViewModalVar } from "~/components/stores/detail-product/store";
import { useMatchMedia } from "~/hooks/use-match-media";
import type { G_VideoSamplePicture } from "~/lib/graphql";
import { Z_INDEX } from "~/styles/z-index";

export type SampleViewerModalProps = {
  /** sample viewer modal表示時に押下されたimageのindex番号 */
  selectedSampleImageIndex: number;
  /** sample viewer modalで表示する画像データ */
  gravureSeasonImageData: Pick<G_VideoSamplePicture, "image" | "imageLarge">[];
};

export const SampleViewerModal = (props: SampleViewerModalProps) => {
  const { selectedSampleImageIndex, gravureSeasonImageData } = props;
  const { isSpSize } = useMatchMedia();

  const isOpenSampleViewerModal = useReactiveVar(isOpenSampleViewModalVar);

  return (
    <PortalModal
      size={isSpSize ? "fullScreen" : "middle"}
      basisZIndex={Z_INDEX.MODAL_IN_MODAL}
      isOpen={isOpenSampleViewerModal}
      onCloseModal={() => isOpenSampleViewModalVar(false)}
      isShowBodyCloseButton
    >
      {!isSpSize ? (
        <DesktopModalBody
          selectedSampleImageIndex={selectedSampleImageIndex}
          gravureSeasonImageData={gravureSeasonImageData}
        />
      ) : (
        <MobileModalBody
          selectedSampleImageIndex={selectedSampleImageIndex}
          gravureSeasonImageData={gravureSeasonImageData}
        />
      )}
    </PortalModal>
  );
};
